import { request } from './client'

export const adminListRaces = () => request('/admin/races')

export const adminGetRace = slug => request(`/admin/races/${encodeURIComponent(slug)}`)

export const adminCreateRace = payload => request('/admin/races', { method: 'POST', body: payload })

export const adminUpdateRace = (slug, payload) => request(`/admin/races/${encodeURIComponent(slug)}`, { method: 'PUT', body: payload })

export const adminDeleteRace = slug => request(`/admin/races/${encodeURIComponent(slug)}`, { method: 'DELETE' })

export const adminListEvents = () => request('/admin/events')

export const adminGetEvent = slug => request(`/admin/events/${encodeURIComponent(slug)}`)

export const adminCreateEvent = payload => request('/admin/events', { method: 'POST', body: payload })

export const adminUpdateEvent = (slug, payload) => request(`/admin/events/${encodeURIComponent(slug)}`, { method: 'PUT', body: payload })

export const adminDeleteEvent = slug => request(`/admin/events/${encodeURIComponent(slug)}`, { method: 'DELETE' })

export async function adminUploadImage (file, folder = 'races') {
  const sig = await request('/admin/uploads/signature', { method: 'POST', body: { folder } })

  const form = new FormData()
  form.append('file', file)
  form.append('api_key', sig.apiKey)
  form.append('timestamp', sig.timestamp)
  form.append('signature', sig.signature)
  form.append('folder', sig.folder)
  if (sig.publicId) form.append('public_id', sig.publicId)

  const res = await fetch(`https://api.cloudinary.com/v1_1/${sig.cloudName}/image/upload`, {
    method: 'POST',
    body: form
  })
  const payload = await res.json().catch(() => ({}))
  if (!res.ok) {
    const err = new Error(payload?.error?.message || `Upload failed (${res.status})`)
    err.status = res.status
    throw err
  }
  return {
    url: payload.secure_url || payload.url,
    publicId: payload.public_id,
    width: payload.width,
    height: payload.height,
    format: payload.format
  }
}
